export default __webpack_public_path__ + "static/bounty-8d6febb644d0958a861a5feb92ed6156.png";